<template>
	<div />
</template>


<script>
	import AppConfig from '@/config';
    import { http } from '@/services';

	export default {
		name: 'licensing',
		beforeCreate() {
			http.get(`${AppConfig.api.baseURL}/legal/copyright`)
			.then((response) => {
                document.open();
				document.write(response.data.content);
				document.close();
			});
		}
	};
</script>